<template>
  <div class="flex gap-1">
    <vs-button
      v-for="(button, index) in buttons"
      :key="index"
      :class="[
        'flex',
        'items-center',
        'justify-center',
        'rounded-full w-8 h-8 p-2',
      ]"
      :color="button.color"
      @click.native="() => handleClick(button, item)"
      :disabled="button.disabled"
    >
      <vs-icon :icon-pack="button.iconPack" :icon="button.icon" size="16px" />
    </vs-button>
  </div>
</template>

<script>
export default {
  name: 'GenericActionsButtons',
  props: {
    buttons: Array,
    item: Object,
  },
  methods: {
    handleClick(button, item) {
      if (button.action && typeof button.action === 'function') {
        button.action(item);
      }
    },
  },
};
</script>
<style lang="scss"></style>
